module.exports = __webpack_public_path__ + "85293d118dddcae20562cc6a9cb89642.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-user-type/sp-user-type.html
// module id = 1140
// module chunks = 0